import React from "react";

import {
  Box,
  Button,
  Divider,
  Flex,
  Select,
  SimpleGrid,
  TextInput,
  createStyles,
  rem,
} from "@mantine/core";

import { removeFacility } from "../../services";
import { RiDeleteBin7Line } from "react-icons/ri";
import swal from "sweetalert";
import ActionButtons from "./ActionButtons";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { stateZipCodes } from "../../utils/zipCodes";

const useStyles = createStyles((theme) => ({
  FacilityDetailsTab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  facilityForm: {
    minWidth: "700px",
  },
}));

export const FacilityDetailsTab = ({
  mode,
  form,
  activeTab,
  handleSave,
  handleCancel,
  loading,
  selectedStateAbbr,
  ...data
}) => {
  const DropDownArrow = (
    <DropDownArrowSvg
      color={"#FBAA0D"}
      style={{ width: rem(1), height: rem(1) }}
    />
  );
  const { classes } = useStyles();

  const handleDeleteFacility = async (event) => {
    event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone. Facility are further associated to Client, Deleting facility can cause problems.",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeFacility(data?.data?.id);
  };

  return (
    <Box>
      {mode !== "add" && (
        <>
          <Flex justify={"flex-end"} mt={10}>
            <Button
              c={"red"}
              color="gray"
              variant="transparent"
              className={classes.delete}
              onClick={handleDeleteFacility}
            >
              <RiDeleteBin7Line size={18} />
              <span style={{ marginLeft: "5px" }}>Delete</span>
            </Button>
          </Flex>
          <Divider my={10} />
        </>
      )}
      <Box className={classes.FacilityDetailsTab}>
        <form onSubmit={form.onSubmit(handleSave)}>
          <Box className={classes.facilityForm}>
            <SimpleGrid
              cols={2}
              className={classes.mwd}
              sx={{
                paddingTop: 20,
              }}
            >
              {/* facility name */}
              <TextInput
                id="facility-name"
                label="Facility Name"
                variant="default"
                size="md"
                radius={"md"}
                placeholder="Ex: Valerie Liberty"
                {...form.getInputProps("name")}
                disabled={mode == "view" ? true : false}
              />
              <TextInput
                id="Phone"
                label="Phone Number"
                variant="default"
                size="md"
                radius={"md"}
                placeholder="Ex: 1234567890"
                {...form.getInputProps("phone")}
                disabled={mode == "view" ? true : false}
              />
            </SimpleGrid>
            <TextInput
              id="address"
              label="Email"
              size="md"
              radius={"md"}
              placeholder="Email Address"
              sx={{ marginTop: 20 }}
              {...form.getInputProps("email")}
              disabled={mode == "view" ? true : false}
            />
            {/* address */}
            <TextInput
              id="address"
              label="Address 1"
              size="md"
              radius={"md"}
              placeholder="Ex: Flate No/House No/Apt No"
              sx={{ marginTop: 20 }}
              {...form.getInputProps("address")}
              disabled={mode == "view" ? true : false}
            />
            {/* address two */}
            <TextInput
              id="address-two"
              label="City"
              size="md"
              radius={"md"}
              sx={{ marginTop: 20 }}
              placeholder="Ex: City Name"
              {...form.getInputProps("location")}
              disabled={mode == "view" ? true : false}
            />
            {/* zipcode */}
            <SimpleGrid cols={2} sx={{ marginTop: 20 }}>
              <TextInput
                id="zipcode"
                label="Zipcode"
                size="md"
                radius={"md"}
                placeholder="Ex: 00001"
                type="number"
                {...form.getInputProps("zip")}
                disabled={mode == "view" ? true : false}
              />
              {/* state */}
              <Select
                id="state"
                searchable
                label="State"
                data={Array.from(
                  new Set(stateZipCodes?.map((obj) => obj.ste_name))
                )
                  .sort()
                  .map((ste_name) => ({
                    value: ste_name,
                    label: ste_name,
                  }))}
                size="md"
                radius={"md"}
                value={selectedStateAbbr}
                placeholder="Choose One"
                {...form.getInputProps("state")}
                disabled={mode == "view" ? true : false}
                rightSection={DropDownArrow}
              />
              
              {/* {mode !== "add" && (
                <Select
                  id="state"
                  searchable
                  label={`${
                    mode == "edit" ? "Previous Selected State" : "State"
                  }`}
                  data={states}
                  size="md"
                  radius={"md"}
                  placeholder="Choose One"
                  {...form.getInputProps("state")}
                  disabled={mode == "view" || mode == "edit" ? true : false}
                  rightSection={DropDownArrow}
                />
              )}
              {(mode === "edit" || mode === "add") && (
                <Select
                  id="state"
                  searchable
                  label="State"
                  data={Array.from(
                    new Set(stateZipCodes?.map((obj) => obj.ste_name))
                  )
                    .sort()
                    .map((ste_name) => ({
                      value: ste_name,
                      label: ste_name,
                    }))}
                  size="md"
                  radius={"md"}
                  placeholder="Choose One"
                  {...form.getInputProps("state")}
                  disabled={mode == "view" ? true : false}
                  rightSection={DropDownArrow}
                />
              )} */}
            </SimpleGrid>
            <SimpleGrid mt={10}>
              <TextInput
                label="License Number"
                radius="md"
                size="md"
                placeholder="Add License Number"
                {...form.getInputProps("providerLicense")}
                disabled={mode == "view" ? true : false}
              />
            </SimpleGrid>
          </Box>
          {(mode === "add" || mode === "edit") && (
            <Box mt={40}>
              <Divider my={10} />
              <ActionButtons
                onCancel={handleCancel}
                type="submit"
                loading={loading}
                isFacility={true}
                activeTab={activeTab}
                // onSave={handleSave}
              />
            </Box>
          )}
        </form>
      </Box>
    </Box>
  );
};
